var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded && _vm.preOrder)?_c('PreOrderDetail',{attrs:{"pre-order-units":_vm.preOrder.units,"pre-order":_vm.preOrder},on:{"orderChanged":_vm.orderChanged,"addUnit":_vm.addUnit,"rowClicked":_vm.rowClicked}}):(_vm.loaded)?_c('Page404',{attrs:{"message":"That Pre-Order was not found"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }